export const onAddOrRemoveButtonClick = (
  vinCriteria: string[],
  setFieldValue: (
    field: string,
    value: string[],
    shouldValidate?: boolean | undefined
  ) => void
): ((index: number, isLast: boolean) => () => void) => {
  return (index: number, isLast: boolean) => (): void => {
    if (isLast) {
      const updatedVinCriteria = ['', ...vinCriteria];
      setFieldValue('vinCriteria', updatedVinCriteria);
    } else {
      const filteredVINs = vinCriteria.filter((_, pos) => pos !== index);
      setFieldValue('vinCriteria', filteredVINs);
    }
  };
};
